<app-loader-circles *ngIf="isBuscandoCep"></app-loader-circles>
<form [formGroup]="currentForm" class="forms">
  <div class="form-group">
    <span class="icon {{ tipoEndereco }}"></span>
    <div class="inputs">
      <label for="cep">Endereço {{ tipoEndereco }} CEP</label>
      <input
          class="form-control"
          type="text"
          placeholder="00000-000"
          mask-number
          inputmode="numeric"
          [mask]="'99999-999'"
          minlength="8"
          maxlength="9"
          required
          appShowErrorMessages
          requiredMessage="O campo Endereço {{ tipoEndereco }} CEP é obrigatório"
          name="cep"
          formControlName="cep"
          appOnlyNumberRestrictive>
      <a title="Consultar site dos correios" target="_blank" href="http://www.buscacep.correios.com.br/sistemas/buscacep/" rel="noopener">Não sabe o CEP?</a>
    </div>
  </div>
  <div *ngIf="exibeCampos">
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="logradouro">Endereço</label>
        <input
            class="form-control"
            type="text"
            placeholder="Rua, Avenida, Alameda..."
            maxlength="50"
            required
            appShowErrorMessages
            requiredMessage="O campo Endereço é obrigatório"
            name="logradouro"
            formControlName="logradouro"
            [readonly]="hasLogradouro">
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs" style="display: flex">
        <div class="small-inputs">
          <label for="numero">Número</label>
          <input
              class="form-control"
              type="text"
              placeholder="Número"
              maxlength="9"
              required
              appShowErrorMessages
              requiredMessage="O campo Número é obrigatório"
              name="numero"
              formControlName="numero"
              inputmode="numeric"
              appOnlyNumberRestrictive>
        </div>
        <div class="big-inputs">
          <label for="complemento">Complemento</label>
          <input
              class="form-control"
              type="text"
              placeholder="Apartamento, Casa..."
              name="complemento"
              formControlName="complemento"
              maxlength="20">
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="bairro">Bairro</label>
        <input
            class="form-control"
            type="text"
            placeholder="Digite o bairro"
            maxlength="40"
            required
            appShowErrorMessages
            requiredMessage="O campo Bairro é obrigatório"
            name="bairro"
            formControlName="bairro"
            [readonly]="hasBairro && !cepUnico">
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs" style="display: flex">
        <div class="small-inputs">
          <label for="uf">UF</label>
          <select
              class="form-control"
              required
              appShowErrorMessages
              requiredMessage="O campo UF é obrigatório"
              name="uf"
              formControlName="uf">
            <option value="" selected disabled>Selecione...</option>
            <option *ngFor="let uf of ufs" value="{{ uf.codigo }}">{{ uf.descricao }}</option>
          </select>
        </div>
        <div class="big-inputs">
          <label for="cidade">Cidade</label>
          <select
              class="form-control"
              required
              appShowErrorMessages
              requiredMessage="O campo Cidade é obrigatório"
              name="cidade"
              formControlName="cidade">
            <option value="" selected disabled>Selecione...</option>
            <option *ngFor="let cidade of cidades" value="{{ cidade }}">{{ cidade }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="form-group">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="referencia">Ponto de Referência</label>
        <textarea
          class="form-control"
          name="referencia"
          placeholder="Próximo à praça..."
          formControlName="referencia"
          cols="30"
          rows="3"
          maxlength="1000"></textarea>
      </div>
    </div>
    <div class="form-group" *ngIf="isResidencial && !isAvalista">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="tipoMoradia">Tipo de residência</label>
        <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Tipo de residência é obrigatório"
            name="tipoMoradia"
            formControlName="tipoMoradia">
          <option value="" selected hidden>Selecione...</option>
          <option *ngFor="let tipoMoradia of tiposMoradias" value="{{ tipoMoradia.id }}">{{ tipoMoradia.description }}</option>
        </select>
      </div>
    </div>
    <div class="form-group" *ngIf="isResidencial && !isAvalista">
      <span class="icon vazio"></span>
      <div class="inputs">
        <label for="tempoResidencia">Mora na residência desde:</label>
        <input
          class="form-control"
          type="text"
          mask-number
          inputmode="numeric"
          [mask]="'99/9999'"
          placeholder="00/0000"
          required
          [dateCheck]="tempoResidencia.value"
          [dateFormat]="'MMYYYY'"
          dateMessage="Data inválida!"
          appShowErrorMessages
          requiredMessage="O campo 'Mora na residência desde' é obrigatório"
          formControlName="tempoResidencia"
          name="tempoResidencia">
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="isResidencial">
    <span class="icon"></span>
    <div class="inputs">
      <label for="tipo-endereco">Copiar dados do endereço residencial para comercial?</label>
      <small class="subtitle">Deseja informar o endereço comercial com os mesmos dados do endereço residencial?</small>
      <div class="input-box" data-toggle="buttons">
        <label class="btn btn-default btn-circle btn-lg" (click)="repetirEndereco(true)">
          <input type="radio" name="q1" value="0">
        </label>
        <span class="radio-label">Sim</span>
        <label class="btn btn-default btn-circle btn-lg active" (click)="repetirEndereco(false)">
          <input type="radio" name="q1" value="1">
        </label>
        <span class="radio-label">Não</span>
      </div>
    </div>
  </div>
</form>

<app-new-modal-message #cepInvalidoModal [showFecharBtn]="false"></app-new-modal-message>
